<template>
  <b-form class="1w-100 form" @submit="onSubmit">
       <b-row cols="2">
          <b-col>
              <h4 style="text-align:left"> Total Disponível</h4>
          </b-col>
          <b-col>
          <b-input-group size="lg" append="%">
               <b-form-input 
            id="totalcommisioning"
             type="number"
             :state="!commissioningInvalid"
              placeholder="100"
            style="color:gray"
           :disabled="true"
            v-model="form.totalcommisioning"
            
           
          ></b-form-input>
  
          </b-input-group>
              
          </b-col>
       </b-row>
    <hr/>
    <b-row cols="2">
      <b-col>
        <b-form-group label="Gerente:" label-for="manager">
          <b-select v-model="form.idManager">
                            <b-select-option value=0>
                              Selecione
                            </b-select-option>
                            <b-select-option
              :value="item.id"
              v-for="(item, index) in managers"
              :key="`manager-${index}`"
            >
              {{ item.fullName }}
            </b-select-option>
                          
          </b-select>

     
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Percentual" label-for="managerValue">
             <b-input-group size="md" append="%">
          <b-form-input 
            id="managerValue"
             type="number"
             :min="0"
  
            v-model="form.managerValue"
           
           
          ></b-form-input>
           </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

       <b-row cols="2">
      <b-col>
        <b-form-group label="Coordenador:" label-for="manager">
          <b-select v-model="form.idCordinator">
                            <b-select-option value=null>
                              Selecione
                            </b-select-option>

                             <b-select-option
              :value="item.id"
              v-for="(item, index) in coordinators"
              :key="`coordinator-${index}`"
            >
              {{ item.fullName }}
            </b-select-option>
                          
          </b-select>

    
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Percentual:" label-for="coordinatorValue">
              <b-input-group size="md" append="%">
          <b-form-input 
            id="coordinatorValue"
            v-model="form.coordinatorValue"
            :min="0"
            type="number"
              
             
          ></b-form-input>
            </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

       <b-row cols="2">
      <b-col>
        <b-form-group label="Supervisor:" label-for="">
          <b-select v-model="form.idSupervisor">
                            <b-select-option value=null>
                              Selecione
                            </b-select-option>
                             <b-select-option
              :value="item.id"
              v-for="(item, index) in supervisors"
              :key="`supervisor-${index}`"
            >
              {{ item.fullName }}
            </b-select-option>
                          
          </b-select>
           

    
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Percentual:" label-for="supervisorValue">
              <b-input-group size="md" append="%">
          <b-form-input 
            id="supervisorValue"
            v-model="form.supervisorValue"
           :min="0"
           :max="100"
            type="number"
            
            
          ></b-form-input>
           </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

        <b-row cols="2">
      <b-col>
        <b-form-group label="Representante:" label-for="manager">
          <b-select v-model="form.idRepresentative">
                            <b-select-option value=null>
                              Selecione
                            </b-select-option>

                              <b-select-option
              :value="item.id"
              v-for="(item, index) in representatives"
              :key="`Representante-${index}`"
            >
              {{ item.fullName }}
            </b-select-option>
                          
          </b-select>

    
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Percentual:" label-for="representativeValue">
              <b-input-group size="md" append="%">
          <b-form-input
            id="representativeValue"
            v-model="form.representativeValue"
            :min="0"
             type="number"
             
              
          ></b-form-input>
           </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

      <b-row cols="2">
      <b-col>
        <b-form-group label="Vendedor:" label-for="salesman">
          <b-select v-model="form.idSalesman">
                            <b-select-option value=null>
                              Selecione
                            </b-select-option>
                                <b-select-option
              :value="item.id"
              v-for="(item, index) in salesmanlist"
              :key="`salesman-${index}`"
            >
              {{ item.fullName }}
            </b-select-option>
                          
          </b-select>

                

    
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group   label="Percentual:" label-for="salesmanValue">
             <b-input-group size="md" append="%">
          <b-form-input
            id="salesmanValue"
            v-model="form.salesmanValue"
             :min="0"
             type="number"
            
             
          ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>


      <hr />

    <div class="row">
      <div class="col-xl">
        <b-btn
          type="submit"
          class="col-md-2"
          variant="outline-primary"
          :disabled="loading || (commissioningInvalid) "
          
          >Salvar 
          <b-spinner
            small
            variant="primary"
            label="Spinning"
            v-show="loading"
          ></b-spinner>
        </b-btn>
      </div>
    </div>

  </b-form>
</template>

<script>
import { get as _get, debounce as _debounce } from 'lodash'
import { mask } from '@titou10/v-mask'
import { UsuarioResource } from "@/resources/Usuario.resource.js";
import {MerchantCommissioningResource} from "@/resources/MerchantCommissioning.resource.js"; 

export default {
     name: "FormMerchantCommissioning",
  directives: { mask },
  props: {
    merchant: {
      type: Object,
      default: function() {
        return {}
      },
    },
  },

  data() {
    return {
      loading: false,
      commissioningInvalid: false,
      loadingPayoutType : false,
      managers: [],
      coordinators: [],
      supervisors:[],
      representatives : [],
      salesmanlist :[],
      merchantCommissioningList: [],
      form: {
        totalcommisioning : 100,
        managerValue:0,
        salesmanValue:0,
        supervisorValue:0,
        representativeValue:0,
        coordinatorValue:0,
        idSalesman :0,
        idManager:0,
        idSupervisor :0,
        idRepresentative:0,
        idCordinator:0

  
      },
      
    }
  },
  computed: {
   
   
  },

  

  watch : {

      "form.idManager": function(v) {
          this.totalcommisioning();
    },
      "form.idCordinator": function(v) {
          this.totalcommisioning();
    },
       "form.idSupervisor": function(v) {
          this.totalcommisioning();
    },

      "form.idSalesman": function(v) {
          this.totalcommisioning();
    },

      "form.idRepresentative": function(v) {
          this.totalcommisioning();
    },
       "form.managerValue": function(v) {
          this.totalcommisioning();
    },
       "form.salesmanValue": function(v) {
        this.totalcommisioning();
    },
       "form.supervisorValue": function(v) {
        this.totalcommisioning();
    },
       "form.representativeValue": function(v) {
        this.totalcommisioning();
    },
      "form.coordinatorValue": function(v) {
       this.totalcommisioning();
    }

  },

  created() {
   
     
      this.load(this.merchant.idMerchant);
      this.getManagers();
      this.getCoordinators();
      this.getSupervisors();
      this.getRepresentatives();
      this.getSalesmans();
     

  },
  methods: {

      getManagers()
      {
          UsuarioResource.getManager()
          .then((result)=>{
           this.managers = result.data.payload.items;
          
          })
          .catch((e)=> {
            // Surpress
          })

      },
       getCoordinators()
      {
          UsuarioResource.getCoordinator()
          .then((result)=>{
           this.coordinators = result.data.payload.items;
          })
          .catch((e)=> {
            // Surpress
          })

      },

     getSupervisors()
      {
          UsuarioResource.getSupervisor()
          .then((result)=>{
           this.supervisors = result.data.payload.items;
          
          })
          .catch((e)=> {
            // Surpress
          })

      },
      getRepresentatives()
      {
          UsuarioResource.getRepresentative()
          .then((result)=>{
           this.representatives = result.data.payload.items;
          
          })
          .catch((e)=> {
            // Surpress
          })

      },
      getSalesmans()
      {
          UsuarioResource.getSalesman()
          .then((result)=>{
           this.salesmanlist = result.data.payload.items;
          
          })
          .catch((e)=> {
            // Surpress
          })

      },


      totalcommisioning()
      {
          const salesmanValue = !isNaN(parseInt(this.form.salesmanValue)) && this.form.idSalesman > 0 ? parseInt(this.form.salesmanValue) : 0;
          const  supervisorValue = !isNaN(parseInt(this.form.supervisorValue))  && this.form.idSupervisor > 0 ?  parseInt (this.form.supervisorValue) : 0;
          const representativeValue = !isNaN(parseInt(this.form.representativeValue)) && this.form.idRepresentative > 0 ?  parseInt(this.form.representativeValue) : 0;
          const coordinatorValue = !isNaN(parseInt(this.form.coordinatorValue)) && this.form.idCordinator > 0 ?  parseInt(this.form.coordinatorValue) : 0;
          const managerValue = !isNaN(parseInt(this.form.managerValue)) && this.form.idManager> 0 ? parseInt(this.form.managerValue) : 0;

         this.form.totalcommisioning =  100 -  (salesmanValue + supervisorValue + representativeValue + coordinatorValue + managerValue )

             this.commissioningInvalid  = this.form.totalcommisioning < 0 ? true : false;

      },

 

    load(idMerchant)
    {

      

         MerchantCommissioningResource.getLista({idMerchant :idMerchant }).then((result) => {
          try{
                this.merchantCommissioningList = result.data.payload  ;

                if(this.merchantCommissioningList.length > 0)
                {
                       var managerValue =  this.merchantCommissioningList.filter(item =>{
                       return  item.idRole === 4 })[0];
                       if(managerValue)
                       {
                          this.form.managerValue = managerValue.percentAmount;
                          this.form.idManager  = managerValue.idUser;
                       }

                       var coordinatorValue =  this.merchantCommissioningList.filter(item =>{
                       return  item.idRole === 5 })[0];
                       if(coordinatorValue)
                       {
                          this.form.coordinatorValue = coordinatorValue.percentAmount;
                          this.form.idCordinator =   coordinatorValue.idUser;
                       }

                       var supervisorValue =  this.merchantCommissioningList.filter(item =>{
                       return  item.idRole === 6 })[0];
                       if(supervisorValue)
                       {
                          this.form.supervisorValue = supervisorValue.percentAmount;
                          this.form.idSupervisor = supervisorValue.idUser;
                       }

                      var representativeValue =  this.merchantCommissioningList.filter(item =>{
                       return  item.idRole === 7 })[0];
                       if(representativeValue)
                       {
                          this.form.representativeValue = representativeValue.percentAmount;
                          this.form.idRepresentative = representativeValue.idUser;
                       }
                         var salesmanValue =  this.merchantCommissioningList.filter(item =>{
                       return  item.idRole === 8 })[0];
                       if(salesmanValue)
                       {
                          this.form.salesmanValue = salesmanValue.percentAmount;
                          this.form.idSalesman = salesmanValue.idUser;
                       }
 
                }
   
                 this.loading = false
          } catch(e) {
            throw {
              response: {
                data: {
                  failureReason: 'Deu ruim na chamada...'
                }
              }
            }
          }
        })
        .catch((e) => { 
          this.loading = false
        }) 
      
   },

   
    
    async onSubmit(e) {
      e.preventDefault()
      this.loading = true

      const data = {
        ...this.form,
        idMerchant: parseInt(this.$route.params.id),
        
      } 

      // create a payload
      let commissioningList = [];
      // validar e fazer para todo hierarquia
      if(data.idManager > 0  && data.managerValue > 0)
      {
        let   managerObj = {
           idRole : 4,
           idMerchant : parseInt(data.idMerchant),
           idUser : parseInt( data.idManager),
           percentAmount : parseInt( data.managerValue)

         };
         commissioningList.push(managerObj);
      }

      if(data.idCordinator > 0  && data.coordinatorValue > 0)
      {
        let   cordinatorObj = {
           idRole : 5,
           idMerchant : parseInt(data.idMerchant),
           idUser : parseInt( data.idCordinator),
           percentAmount : parseInt(data.coordinatorValue)

         };
         commissioningList.push(cordinatorObj);
      }
       if(data.idSupervisor > 0  && data.supervisorValue > 0)
      {
        let   supervisorObj = {
           idRole : 6,
           idMerchant : parseInt(data.idMerchant),
           idUser :parseInt( data.idSupervisor),
           percentAmount : parseInt( data.supervisorValue)

         };
         commissioningList.push(supervisorObj);
      }

      if(data.idRepresentative > 0  && data.representativeValue > 0)
      {
        let  representativeObj = {
           idRole : 7,
           idMerchant : parseInt(data.idMerchant),
           idUser : parseInt(data.idRepresentative),
           percentAmount : parseInt( data.representativeValue)

         };
         commissioningList.push(representativeObj);
      }

       if(data.idSalesman > 0  && data.salesmanValue > 0)
      {
        let   salesmanObj = {
           idRole : 8,
           idMerchant : parseInt(data.idMerchant),
           idUser : parseInt(data.idSalesman),
           percentAmount  : parseInt( data.salesmanValue)

         };
         commissioningList.push(salesmanObj);
      }
      

      MerchantCommissioningResource.save({merchantCommissioningList : commissioningList})
      .then(result=>{
          this.loading = false;
            this.$notification['success']({
                    message: 'Registro Salvo',
                    description: '',
                  })

      })

      .catch((e)=>{
           this.loading = false;
            this.$notification['error']({
                    message: 'Ocorreu um erro',
                    description: '',
                  })
      })

        


    },

 
  },
}
</script>

<style lang="css">
.width-150 {
  width: 150px;
}
.form .is-invalid,
.form .is-valid {
  padding-right: 0;
}
</style>
